<div class="dialog">
    @if (modalControl) {
        <button
            type="button"
            class="dialog__close"
            (click)="handleClose()"
            title="Dismiss dialog"
            aria-label="Dismiss dialog"
            data-application="close-modal-button"
        ></button>
    }
    <website-image
        [src]="defaultImage"
        [width]="60"
        [height]="60"
        [config]="imageConfig"
        [isDecorative]="true"
    ></website-image>
    <h3 class="dialog__title" dir="auto" [innerHTML]="strings.title"></h3>
    <div class="dialog__content">
        <p class="dialog__message" dir="auto" [innerHTML]="strings.message"></p>
    </div>
    <div class="dialog__actions" [class.dialog__actions--multiple]="!isSecondaryButtonHidden">
        <button
            website-button-v3
            [buttonStyleProperties]="buttonStyleProperties"
            (click)="handleAnswer('primary')"
            [innerHTML]="strings.primaryButtonText"
            data-dialog-button-primary
        ></button>
        @if (!isSecondaryButtonHidden) {
            <button
                website-button-v3
                [buttonStyleProperties]="secondaryButtonStyleProperties"
                (click)="handleAnswer('secondary')"
                [innerHTML]="strings.secondaryButtonText"
                data-dialog-button-secondary
            ></button>
        }
    </div>
</div>
